import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Common from "../../../helpers/common";
import { respEnum, TransactionLogStatusEnum, TransactionLogTypeEnum, PaymentTypeEnum } from "../../../constants/appConstants";
import { useSelector, useDispatch } from "react-redux";
import { getBookingPayload, setBookingPayload } from "../../../store/bookingSlice";
import Swal from 'sweetalert2';
import './PaymentStatus.css'; // We'll create this CSS file

const PaymentStatus = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [countdown, setCountdown] = useState(4);
    const [showBookingSuccessModal, setShowBookingSuccessModal] = useState(false);
    const [bookingSuccessData, setBookingSuccessData] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // Decrypt and parse the booking payload
    const encryptedPayload = localStorage.getItem('bookingPayload');
    let bookingPayload = null;
    try {
        if (encryptedPayload) {
            bookingPayload = JSON.parse(atob(encryptedPayload));
        }
    } catch (error) {
        // Handle decryption error silently for security
        bookingPayload = null;
    }

    const errorMessages = {
        "00": "Processed OK",
        "002": "Time Out",
        "97": "Insufficient balance to proceed",
        "106": "Transaction limit exceeded, please contact your bank",
        "03": "Inactive account entered",
        "104": "Incorrect details entered",
        "55": "Invalid OTP/PIN entered",
        "54": "Card expired",
        "13": "Invalid amount entered",
        "126": "Provided account details are invalid",
        "75": "Maximum PIN retries exceeded",
        "14": "Inactive card number entered",
        "15": "Inactive card number entered",
        "42": "Invalid CNIC entered",
        "423": "Unable to process your request at the moment, please try again later",
        "41": "Details entered are mismatched",
        "801": "OTP sent to your email address",
        "802": "OTP could not be sent, please try again later",
        "803": "OTP sent to your mobile number",
        "805": "OTP verified",
        "806": "OTP could not be verified",
        "807": "Too many attempts, please try again later in a few minutes",
        "808": "Passwords do not match",
        "809": "Invalid password",
        "810": "Password could not be changed",
        "811": "Password changed successfully",
        "812": "Request could not be validated, please try again",
        "813": "Email address already registered",
        "9000": "FRMS rejected",
        "9010": "FRMS error",
        "308": "Provided account details are invalid",
        "600": "OTP already expired",
        "309": "Invalid OTP length entered",
        "853": "Provided account details are invalid",
        "04": "Closed account entered",
        "537": "Dormant account entered",
        "359": "Blocked account",
        "880": "Transaction declined due to non-activation of local ecommerce session, please call your bank",
        "881": "Transaction declined due to insufficient funds, please call your bank for assistance",
        "882": "Transaction declined due to consumption of daily local epayment transaction limit/count",
        "883": "Transaction declined, please call your bank to activate local epayment service",
        "901": "Transaction cancelled by user"
    };

    // Booking Success Modal Component
    const BookingSuccessModal = ({ show, onClose, bookingData }) => {
        if (!show || !bookingData) return null;

        const formatDateTime = (dateTimeString) => {
            if (!dateTimeString) return 'N/A';
            try {
                const date = new Date(dateTimeString);
                return date.toLocaleDateString('en-US', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            } catch (error) {
                return dateTimeString;
            }
        };

        const formatTime = (startDateTime, endDateTime) => {
            if (!startDateTime || !endDateTime) return 'N/A';
            try {
                const start = new Date(startDateTime);
                const end = new Date(endDateTime);
                const startTime = start.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                });
                const endTime = end.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                });
                return `${startTime} - ${endTime}`;
            } catch (error) {
                return 'N/A';
            }
        };

        const getPaymentModeDisplay = (paymentTypeId) => {
            if (paymentTypeId === PaymentTypeEnum.Pay_On_Club || paymentTypeId === "Pay_On_Club") {
                return "Pay on Club";
            } else if (paymentTypeId === PaymentTypeEnum.Payment_GateWay || paymentTypeId === "Payment_GateWay") {
                return "PayFast Gateway";
            } else if (paymentTypeId === PaymentTypeEnum.Online_Partial_Pay || paymentTypeId === "Online_Partial_Pay") {
                return "Partial Payment";
            }
            return "Online Payment";
        };

        const getPaymentModeIcon = (paymentTypeId) => {
            if (paymentTypeId === PaymentTypeEnum.Pay_On_Club || paymentTypeId === "Pay_On_Club") {
                return "🏪";
            } else if (paymentTypeId === PaymentTypeEnum.Payment_GateWay || paymentTypeId === "Payment_GateWay") {
                return "💳";
            } else if (paymentTypeId === PaymentTypeEnum.Online_Partial_Pay || paymentTypeId === "Online_Partial_Pay") {
                return "💰";
            }
            return "💳";
        };

        return (
            <div
                className="modal fade show"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    backdropFilter: 'blur(5px)',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 1050
                }}
                onClick={onClose}
            >
                <div
                    className="modal-dialog modal-content-cus-sm"
                    style={{

                        width: '90%',
                        margin: '0',

                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div
                        className="modal-content modal-content-cus-sm"
                        style={{
                            marginTop: '350px !important',
                            marginBottom: '50px !important',
                            backgroundColor: '#1a1a1a',
                            border: '2px solid #28a745',
                            borderRadius: '15px',
                            boxShadow: '0 20px 40px rgba(40, 167, 69, 0.3)'
                        }}
                    >
                        {/* Header */}
                        <div
                            className="modal-header text-center"
                            style={{
                                backgroundColor: '#28a745',
                                borderBottom: 'none',
                                borderRadius: '13px 13px 0 0',
                                padding: '20px 15px'
                            }}
                        >
                            <div className="w-100 text-center">
                                <div style={{ marginBottom: '8px' }}>🎉</div>
                                <h3 className="modal-title text-white mb-0" style={{ fontWeight: 'bold' }}>
                                    Booking Confirmed!
                                </h3>
                                <p className="text-white-50 mb-0" style={{ fontSize: '14px' }}>
                                    Your court has been successfully booked
                                </p>
                            </div>
                            {/* <button
                                type="button"
                                className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
                                onClick={onClose}
                                style={{ }}
                            ></button> */}
                        </div>

                        {/* Body */}
                        <div className="modal-body" style={{ padding: '15px 12px', color: '#ffffff' }}>
                            {/* Booking Reference */}
                            <div className="text-center mb-2">
                                <div
                                    style={{
                                        backgroundColor: '#2a2a2a',
                                        padding: '10px',
                                        borderRadius: '6px',
                                        border: '1px solid #3d3d3d'
                                    }}
                                >
                                    <small style={{ color: '#aaa' }}>BOOKING REFERENCE</small>
                                    <div style={{ fontWeight: 'bold', color: '#28a745', marginTop: '3px' }}>
                                        #{bookingData.refNo || bookingData.id || 'N/A'}
                                    </div>
                                </div>
                            </div>

                            {/* Booking Details Grid */}
                            <div className="row g-1">
                                {/* Court & Sport Info */}
                                <div className="col-md-6">
                                    <div
                                        style={{
                                            backgroundColor: '#2a2a2a',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            border: '1px solid #3d3d3d',
                                            height: '100%'
                                        }}
                                    >
                                        <div className="d-flex align-items-center mb-1">
                                            <span style={{ marginRight: '6px' }}>🏟️</span>
                                            <h6 className="mb-0" style={{ color: '#28a745' }}>Court Details</h6>
                                        </div>
                                        <div className="mb-1">
                                            <small style={{ color: '#aaa' }}>Court</small>
                                            <div style={{ fontWeight: '600' }}>{bookingData.courtName || 'N/A'}</div>
                                        </div>
                                        <div>
                                            <small style={{ color: '#aaa' }}>Sport</small>
                                            <div style={{ fontWeight: '600' }}>{bookingData.sportName || 'N/A'}</div>
                                        </div>
                                    </div>
                                </div>

                                {/* Date & Time Info */}
                                <div className="col-md-6">
                                    <div
                                        style={{
                                            backgroundColor: '#2a2a2a',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            border: '1px solid #3d3d3d',
                                            height: '100%'
                                        }}
                                    >
                                        <div className="d-flex align-items-center mb-1">
                                            <span style={{ marginRight: '6px' }}>📅</span>
                                            <h6 className="mb-0" style={{ color: '#28a745' }}>Schedule</h6>
                                        </div>
                                        <div className="mb-1">
                                            <small style={{ color: '#aaa' }}>Date</small>
                                            <div style={{ fontWeight: '600' }}>{formatDateTime(bookingData.startDateTime)}</div>
                                        </div>
                                        <div>
                                            <small style={{ color: '#aaa' }}>Time Slot</small>
                                            <div style={{ fontWeight: '600' }}>{formatTime(bookingData.startDateTime, bookingData.endDateTime)}</div>
                                        </div>
                                    </div>
                                </div>

                                {/* Payment Info */}
                                <div className="col-md-6">
                                    <div
                                        style={{
                                            backgroundColor: '#2a2a2a',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            border: '1px solid #3d3d3d',
                                            height: '100%'
                                        }}
                                    >
                                        <div className="d-flex align-items-center mb-1">
                                            <span style={{ marginRight: '6px' }}>
                                                {getPaymentModeIcon(bookingData.paymentTypeId)}
                                            </span>
                                            <h6 className="mb-0" style={{ color: '#28a745' }}>Payment Details</h6>
                                        </div>
                                        <div className="mb-1">
                                            <small style={{ color: '#aaa' }}>Payment Mode</small>
                                            <div style={{ fontWeight: '600' }}>{getPaymentModeDisplay(bookingData.paymentTypeId)}</div>
                                        </div>
                                        <div>
                                            <small style={{ color: '#aaa' }}>Status</small>
                                            <div>
                                                <span
                                                    style={{
                                                        backgroundColor: '#28a745',
                                                        color: 'white',
                                                        padding: '2px 5px',
                                                        borderRadius: '3px',

                                                        fontWeight: '600'
                                                    }}
                                                >
                                                    Paid
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Amount Breakdown */}
                                <div className="col-md-6">
                                    <div
                                        style={{
                                            backgroundColor: '#2a2a2a',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            border: '1px solid #3d3d3d',
                                            height: '100%'
                                        }}
                                    >
                                        <div className="d-flex align-items-center mb-1">
                                            <span style={{ marginRight: '6px' }}>💰</span>
                                            <h6 className="mb-0" style={{ color: '#28a745' }}>Amount Details</h6>
                                        </div>
                                        <div className="d-flex justify-content-between mb-1">
                                            <small style={{ color: '#aaa' }}>Court Charges:</small>
                                            <span style={{ fontWeight: '600' }}>Rs. {bookingData.clubDiscount > 0 ? bookingData.originalCourtCharges : (bookingData.courtcharges || 0)}</span>
                                        </div>
                                        {bookingData.clubDiscount > 0 && (
                                            <div className="d-flex justify-content-between mb-1">
                                                <small style={{ color: '#aaa' }}>Club Discount ({bookingData.clubDiscount % 1 === 0 ? bookingData.clubDiscount : bookingData.clubDiscount.toFixed(2)}%):</small>
                                                <span style={{ fontWeight: '600', color: 'rgb(0, 243, 255)' }}>
                                                    -Rs. {Math.round(bookingData.originalCourtCharges * (bookingData.clubDiscount / 100))}
                                                </span>
                                            </div>
                                        )}
                                        {(bookingData.clubDiscount === 0 || !bookingData.clubDiscount) && bookingData.discountAmount > 0 && (
                                            <div className="d-flex justify-content-between mb-1">
                                                <small style={{ color: '#aaa' }}>Promo Discount:</small>
                                                <span style={{ fontWeight: '600', color: '#28a745' }}>
                                                    -Rs. {bookingData.discountAmount || 0}
                                                </span>
                                            </div>
                                        )}
                                        <div className="d-flex justify-content-between mb-1">
                                            <small style={{ color: '#aaa' }}>Platform Fee:</small>
                                            <span style={{ fontWeight: '600' }}>Rs. {bookingData.platformfee || 0}</span>
                                        </div>
                                        <hr style={{ borderColor: '#3d3d3d', margin: '6px 0' }} />
                                        <div className="d-flex justify-content-between mb-1">
                                            <strong style={{ color: '#28a745' }}>Total Amount:</strong>
                                            <strong style={{ color: '#28a745' }}>Rs. {bookingData.total}</strong>
                                        </div>
                                        <div className="d-flex justify-content-between mb-1">
                                            <small style={{ color: '#aaa' }}>Paid Amount:</small>
                                            <span style={{ fontWeight: '600' }}>Rs. {bookingData.receivedAmount || bookingData.total}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <small style={{ color: '#aaa' }}>Remaining:</small>
                                            <span style={{ fontWeight: '600', color: '#28a745' }}>
                                                Rs. {bookingData.remainingAmount || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Promo Code Info (if applicable) */}
                            {bookingData.promocode && (
                                <div className="mt-2">
                                    <div
                                        style={{
                                            backgroundColor: '#2a2a2a',
                                            padding: '12px',
                                            borderRadius: '8px',
                                            border: '1px solid #28a745'
                                        }}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span style={{ marginRight: '8px' }}>🎫</span>
                                            <div>
                                                <small style={{ color: '#28a745' }}>Promo Code Applied</small>
                                                <div style={{ fontWeight: '600' }}>{bookingData.promocode}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        <div
                            className="modal-footer justify-content-center"
                            style={{
                                borderTop: '1px solid #3d3d3d',
                                padding: '12px'
                            }}
                        >
                            <button
                                type="button"
                                className="btn btn-success px-3"
                                onClick={() => {
                                    onClose();
                                    navigate('/dashboard?tab=bookings');
                                }}
                                style={{
                                    backgroundColor: '#28a745',
                                    borderColor: '#28a745',
                                    fontWeight: '600',
                                    borderRadius: '6px',
                                    padding: '8px 20px',

                                }}
                            >
                                <span style={{ marginRight: '5px' }}>📋</span>
                                View My Bookings
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    useEffect(() => {
        handleTransactionStatus();
    }, []);

    useEffect(() => {
        let timer;
        if (error && countdown > 0) {
            timer = setInterval(() => {
                setCountdown(prev => prev - 1);
            }, 1000);
        } else if (countdown === 0) {
            navigate('/shop/booking');
        }
        return () => clearInterval(timer);
    }, [error, countdown]);


    useEffect(() => {
        // Disable back button
        const preventNavigation = (e) => {
            e.preventDefault();
            e.returnValue = ''; // This is required for Chrome
        };

        // Disable browser navigation when component mounts
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', preventNavigation);
        window.addEventListener('beforeunload', preventNavigation);

        // Cleanup when component unmounts
        return () => {
            window.removeEventListener('popstate', preventNavigation);
            window.removeEventListener('beforeunload', preventNavigation);
        };
    }, []);

    // Add this to handle keyboard navigation
    useEffect(() => {
        const preventKeyboardNavigation = (e) => {
            if (e.key === 'Backspace' ||
                (e.altKey && e.key === 'ArrowLeft') || // Alt + Left arrow
                (e.altKey && e.key === 'ArrowRight')) { // Alt + Right arrow
                e.preventDefault();
            }
        };

        // Add keyboard event listener
        window.addEventListener('keydown', preventKeyboardNavigation);

        // Cleanup
        return () => {
            window.removeEventListener('keydown', preventKeyboardNavigation);
        };
    }, []);

    const handleTransactionStatus = async () => {
        try {
            // Get stored booking data
            const storedData = localStorage.getItem('bookingPayload');
            debugger;
            if (!storedData) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Booking information not found',
                    confirmButtonText: 'Go Back to Booking',
                }).then(() => {
                    navigate('/shop/booking');
                });
                return;
            }

            // Decrypt the stored data
            const decryptedData = JSON.parse(atob(storedData));
            const { data: bookingPayload, expiry, transactionToken } = decryptedData;

            // Check if booking data has expired
            if (Date.now() > expiry) {
                localStorage.removeItem('bookingPayload');
                Swal.fire({
                    icon: 'error',
                    title: 'Session Expired',
                    text: 'Booking session has expired. Please try booking again.',
                    confirmButtonText: 'Try Again',
                }).then(() => {
                    navigate('/shop/booking');
                });
                return;
            }

            // Check if this transaction was already processed
            const processedToken = sessionStorage.getItem('processedTransaction');
            if (processedToken === transactionToken) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Already Processed',
                    text: 'This transaction has already been processed.',
                    confirmButtonText: 'Go Back',
                }).then(() => {
                    navigate('/shop/booking');
                });
                return;
            }

            const urlParams = new URLSearchParams(window.location.search);
            const errorCode = urlParams.get('err_code');
            const basketId = urlParams.get('basket_id');

            const payload = {
                isPlayerCancel: errorCode === '901',
                transactionId: urlParams.get('transaction_id'),
                transactionLogType: TransactionLogTypeEnum.Court_Booking,
                transactionLogStatus: errorCode === '000' || errorCode === '00'
                    ? TransactionLogStatusEnum.Success
                    : TransactionLogStatusEnum.Failed,
                basketId: parseInt(basketId),
                err_code: errorCode,
                err_msg: urlParams.get('err_msg'),
                validation_hash: urlParams.get('validation_hash'),
                response: JSON.stringify(Object.fromEntries(urlParams))
            };

            const response = await Common.ApiService.getInstance().request(
                "UpdateTransactionLog",
                payload,
                'POST',
                true,
                true,
                true
            );

            if (response.status === respEnum.Success) {
                if (errorCode === '000' || errorCode === '00') {
                    const finalBookingPayload = {
                        ...bookingPayload,
                        transactionLogId: parseInt(basketId)
                    };

                    const bookingResponse = await Common.ApiService.getInstance().request(
                        "AddBooking",
                        finalBookingPayload,
                        'POST',
                        true,
                        true,
                        true
                    );

                    if (bookingResponse.status === respEnum.Success) {
                        // Mark this transaction as processed
                        sessionStorage.setItem('processedTransaction', transactionToken);

                        // Prepare booking success data for the modal using finalBookingPayload
                        const apiResponse = bookingResponse.data;
                        const bookingData = {
                            // Basic booking info (refNo from API response, rest from payload)
                            id: apiResponse.refNo || apiResponse.id || 'N/A',
                            refNo: apiResponse || 'N/A',

                            // Court and sport details (from finalBookingPayload)
                            courtName: finalBookingPayload.courtName || 'N/A',
                            sportName: finalBookingPayload.sportName || 'N/A',

                            // Date and time (from finalBookingPayload)
                            startDateTime: finalBookingPayload.startDateTime || finalBookingPayload.startDatetime,
                            endDateTime: finalBookingPayload.endDateTime || finalBookingPayload.endDatetime,

                            // Payment details (from finalBookingPayload)
                            paymentTypeId: finalBookingPayload.paymentTypeId,

                            // Amount details (from finalBookingPayload)
                            total: finalBookingPayload.finalAmount || finalBookingPayload.totalAmount || 0,
                            courtcharges: finalBookingPayload.courtcharges || finalBookingPayload.totalAmount || 0,
                            platformfee: finalBookingPayload.platformFee || 0,
                            discountAmount: finalBookingPayload.discountAmount || finalBookingPayload.promocodeAmt || 0,
                            receivedAmount: finalBookingPayload.finalAmount || finalBookingPayload.totalAmount || 0,
                            remainingAmount: 0, // PayFast is full payment

                            // Club discount details (from finalBookingPayload)
                            clubDiscount: finalBookingPayload.clubDiscount || 0,
                            originalCourtCharges: finalBookingPayload.originalCourtCharges || finalBookingPayload.courtcharges || 0,

                            // Promo code (from finalBookingPayload)
                            promocode: finalBookingPayload.promocode || null
                        };

                        // Show the booking success modal
                        setBookingSuccessData(finalBookingPayload);
                        setShowBookingSuccessModal(true);

                        // Clear storage
                        localStorage.removeItem('bookingPayload');
                        dispatch(setBookingPayload(null));

                        // Refresh booking state to trigger time slots refresh
                        // This will be handled by the parent booking component if needed

                        setIsLoading(false);
                        return;
                    }
                }

                setError({
                    code: errorCode,
                    message: errorMessages[errorCode] || "An unknown error occurred"
                });
            } else {
                setError({
                    code: "API_ERROR",
                    message: "Failed to process transaction"
                });
            }
        } catch (error) {
            // console.error("Error processing transaction:", error);
            Swal.fire({
                icon: 'error',
                title: 'Processing Error',
                text: error.message || 'An error occurred while processing your payment',
                confirmButtonText: 'Try Again',
            }).then(() => {
                navigate('/shop/booking');
            });
        } finally {
            setIsLoading(false);
        }
    };

    // Add cleanup on component unmount
    useEffect(() => {
        return () => {
            // Clear any error states when leaving the page
            setError(null);
            setCountdown(4);
        };
    }, []);

    if (isLoading) {
        return (
            <div className="payment-status-container">
                <div className="loading-animation">
                    <div className="spinner"></div>
                    <p className="loading-text">Processing your payment...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="payment-status-container">
                <div className="status-card error">
                    <div className="status-icon error">
                        <svg className="error-icon" viewBox="0 0 24 24">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                        </svg>
                    </div>
                    <h1 className="status-title">Payment Failed</h1>
                    <p className="status-message">{error.message}</p>
                    <div className="countdown-container">
                        <p className="countdown-text">
                            Redirecting to booking page in <span className="countdown-number">{countdown}</span> seconds
                        </p>
                        <div className="progress-bar">
                            <div
                                className="progress"
                                style={{ width: `${(countdown / 4) * 100}%` }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <style>{`
              .modal-content {
                margin-top: 200px !important;
                margin-bottom: 50px !important;
              }
            `}</style>
            <div className="payment-status-container">
                <div className="status-card success">
                    <div className="status-icon success">
                        <svg className="success-icon" viewBox="0 0 24 24">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        </svg>
                    </div>
                    <div className="success-animation">
                        <h1 className="status-title">Payment Successful!</h1>
                        <div className="success-checkmark">✓</div>
                        <p className="status-message">Processing your booking...</p>
                    </div>
                </div>
            </div>

            {/* Booking Success Modal */}
            <BookingSuccessModal
                show={showBookingSuccessModal}
                onClose={() => {
                    setShowBookingSuccessModal(false);
                    setBookingSuccessData(null);
                }}
                bookingData={bookingSuccessData}
            />
        </>
    );
};

export default PaymentStatus; 